import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../../../../utils/icons";
import { useStyles } from "./styles";

interface CategoryBoxProps {
  categories: CategoryPropsBox[],
  flexColums: boolean
}

interface DropList {
  currentDropDownId: number,
  name: string,
  currentNode: number,
  nextValues: DropList[],
  requiredText?: boolean
}

interface CategoryPropsBox {
  id: number,
  reportFolioId: number,
  categoryId: number,
  category: string
  subcategoryId: number,
  subcategory: string,
  priorityId: number,
  priority: string,
  requestText: boolean,
  userAssignId: number,
  configAnswer: {currentNode: number, id: number, name: string}[] | null,
  listText?: string,
  createTime: string,
  updateTime: string,
  deleteTime: string,
  dropDownLinks: DropList[]
}


export const CategoryBox = ({ categories, flexColums }: CategoryBoxProps) => {

  const { t } = useTranslation()
  const styles = useStyles()

  const getSubNames = (configAnswer: {currentNode: number, id: number, name: string}[],subCategorytext:string) => {

    const names = configAnswer.map(item => item.name);

    const result = names.join(" / ");

    const resultWithText = configAnswer.length ? `${result} ${subCategorytext.trim().length > 0 ? ` : ${subCategorytext}` : ''}` : subCategorytext.trim().length > 0 ? subCategorytext : ''

   return (
      <Box sx={styles.dropList}>
        <Typography variant="body2">
          {resultWithText}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={styles.topContainer}>
      <Typography mb={1} variant="h6">{t('reportFolio.detail.general.categoryFull')}</Typography>
      <Box sx={styles.categoriesContainer(flexColums)}>
        {categories.map((sub) => (
        <Box key={sub.id} sx={styles.mainContainer((sub.configAnswer ?? []).length>0 || (sub.listText?.trim() ?? '').length > 0, flexColums)}>
          <Box sx={styles.iconSetting} >{icons('setting')}</Box>

          <Box sx={styles.superior}>
            <Typography variant="subtitle1" fontWeight="bold">{`${sub.category} / ${sub.subcategory}`}</Typography>

            <Box>
              {(sub.configAnswer || (sub.listText?.trim() ?? '').length > 0) && (<>{getSubNames(sub.configAnswer ?? [],sub.listText ?? '')}</>)}
            </Box>
          </Box>

        </Box>
      ))}
      </Box>
    </Box>
  );
};